module.exports = __webpack_public_path__ + "img/one.6dfb5610.png";